// import 'bootstrap';
// import 'mdbootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'mdbootstrap/css/mdb.min.css';
global.jQuery = require('jquery');
global.$ = global.jQuery;

import * as core from '../libs/tech.core'
import * as lazyLoad from '../libs/tech.lazy-load'
import * as scrollup from '../libs/tech.scrollup'
import * as blogLikes from '../libs/tech.blogLikes'
import * as shared from '../libs/tech.shared'
import * as blogDetails from '../libs/tech.blog-details'

$(function () {
    lazyLoad.initLazyLoad('.lazyBackground');
    lazyLoad.initLazyLoad('.swiper-container');
})

//more imports here

export {core, lazyLoad, scrollup, blogLikes, shared, blogDetails}
